export default __webpack_public_path__ + "static/Events-2137140bd0a569cacb796b98e04f0e58.png";